import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  width: 440px;
  height: 260px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 16px;
  background: linear-gradient(90deg, #186ae5 0%, #4282ef 100%);
  /* background: var(--secondary80, #4282ef); */
`

const Title = styled.div`
  color: var(--base-white100, #fff);
  text-align: center;
  font-family: SUIT;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const Content = styled.div`
  color: var(--base-white100, #fff);
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const SelectWrapper = styled.div`
  display: flex;
  width: 140px;
  padding: 8px 10px;
  justify-content: space-between;
  align-items: center;

  border-radius: 8px;
  border: 1px solid var(--secondary100, #1b60d6);
  background: var(--secondary90, #2669de);
`

const StyledSelect = styled.select`
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border: transparent;
  background-color: transparent;
  color: #ffffff;
  width: 150px;

  &:focus {
    outline: none;
    border-color: #58e844;
  }
`

const StyledOption = styled.option`
  color: #333;
  background-color: white;
  padding: 10px;
`

const Illust = styled.div`
  width: 421px;
  height: 143px;
  flex-shrink: 0;
  background: url("/assets/illust2.png") center / cover no-repeat;
  background-color: transparent; /* 기본 배경색 제거 */
`

interface Props {
  title: string
  value: string
  setValue: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const CardIllust2 = (props: Props) => {
  const { title, value, setValue } = props

  return (
    <Wrapper>
      <Title>{title}</Title>
      <ContentWrapper>
        <svg
          width="11"
          height="20"
          viewBox="0 0 11 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 0C3.91846 0 2.63636 1.27919 2.63636 2.85714C2.63636 3.03277 2.65232 3.20488 2.68286 3.37203C1.57053 3.57436 0.727273 4.54607 0.727273 5.71429C0.727273 6.3632 0.987463 6.95149 1.40943 7.38095C0.987463 7.81042 0.727273 8.3987 0.727273 9.04762C0.727273 10.3626 1.79568 11.4286 3.11364 11.4286H4.78409V15.8946L1.47213 12.5902C1.19255 12.3112 0.739265 12.3112 0.459685 12.5902C0.180105 12.8691 0.180105 13.3214 0.459685 13.6003L4.78409 17.9149V19.2857C4.78409 19.6802 5.10461 20 5.5 20C5.89539 20 6.21591 19.6802 6.21591 19.2857V17.9149L10.5403 13.6003C10.8199 13.3214 10.8199 12.8691 10.5403 12.5902C10.2607 12.3112 9.80745 12.3112 9.52787 12.5902L6.21591 15.8946V11.4286H7.88636C9.20432 11.4286 10.2727 10.3626 10.2727 9.04762C10.2727 8.3987 10.0125 7.81042 9.59057 7.38095C10.0125 6.95149 10.2727 6.3632 10.2727 5.71429C10.2727 4.54607 9.42947 3.57436 8.31714 3.37203C8.34768 3.20488 8.36364 3.03277 8.36364 2.85714C8.36364 1.27919 7.08154 0 5.5 0Z"
            fill="white"
          />
        </svg>
        <Content>농장 선택</Content>
        <SelectWrapper>
          <StyledSelect value={value} onChange={setValue}>
            <StyledOption value="정읍">정읍 실증단지</StyledOption>
            {/* <StyledOption value="대전">대전</StyledOption>
            <StyledOption value="보령">보령</StyledOption>
            <StyledOption value="여수">여수</StyledOption> */}
          </StyledSelect>
        </SelectWrapper>
      </ContentWrapper>
      <Illust />
    </Wrapper>
  )
}

export default CardIllust2
